import ApiService from '@/services/core/api.service'

const TypeService = {
  async get (query) {
    return ApiService.get(`admin/types?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/types', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/types/${payload.id}`, payload)
  }
}

export default TypeService
